import { ALERT_MESSAGES } from "../constants/jobs";
import { isValidZipCode } from "./validators";

export function getPromptMessage() {
    return ALERT_MESSAGES.NOT_SAVED
}

export function getCanFetchServiceableZipCode(brandId, franchiseId, zip, country) {
    return brandId && franchiseId && zip && isValidZipCode(zip, country) && country
}